@if (schoolId) {
  <nav class="sidebar" aria-label="NPC Admin Navigation">
    <div class="sidebar-sticky">
      <div class="sidebar-nav">
        @if ((user | async)?.admin) {
          <ul class="nav nav--schools">
            <li class="nav-item">
              <a class="nav-link" [routerLink]="'/schools'" routerLinkActive="active" #rlaSchools="routerLinkActive" [attr.aria-current]="rlaSchools.isActive ? 'page' : null">Change Schools</a>
            </li>
          </ul>
        }

        <p class="sidebar-heading" id="nav-overview">Overview</p>
        <ul class="nav" aria-labelledby="nav-overview">
          <li class="nav-item">
            <a class="nav-link" [routerLink]="['/', schoolId, 'dashboard']" routerLinkActive="active" #rla1="routerLinkActive" [attr.aria-current]="rla1.isActive ? 'page' : null"> <img class="icon" src="./assets/images/icons8-speed.svg" alt="" />Dashboard </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" [routerLink]="['/', schoolId, 'inspector']" routerLinkActive="active" #rla2="routerLinkActive" [attr.aria-current]="rla2.isActive ? 'page' : null"> <img class="icon" src="./assets/images/icons8-telescope.svg" alt="" />Inspector </a>
          </li>
        </ul>

        <p class="sidebar-heading" id="nav-annual-updates">Annual updates</p>
        <ul class="nav" aria-labelledby="nav-annual-updates">
          <li class="nav-item">
            <a class="nav-link" [routerLink]="['/', schoolId, 'costs']" routerLinkActive="active" #rla7="routerLinkActive" [attr.aria-current]="rla7.isActive ? 'page' : null"> <img class="icon" src="./assets/images/icons8-money.svg" alt="" />Costs </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" [routerLink]="['/', schoolId, 'packaging']" routerLinkActive="active" #rla8="routerLinkActive" [attr.aria-current]="rla8.isActive ? 'page' : null"> <img class="icon" src="./assets/images/icons8-open_box.svg" alt="" />Packaging </a>
          </li>
        </ul>

        <p class="sidebar-heading" id="nav-related-setup">Related setup</p>
        <ul class="nav" aria-labelledby="nav-related-setup">
          <li class="nav-item">
            <a class="nav-link" [routerLink]="['/', schoolId, 'questions']" routerLinkActive="active" #rla6="routerLinkActive" [attr.aria-current]="rla6.isActive ? 'page' : null"> <img class="icon" src="./assets/images/icons8-ask_question.svg" alt="" />Questions </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" [routerLink]="['/', schoolId, 'populations']" routerLinkActive="active" #rla9="routerLinkActive" [attr.aria-current]="rla9.isActive ? 'page' : null"> <img class="icon" src="./assets/images/icons8-groups.svg" alt="" />Populations </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" [routerLink]="['/', schoolId, 'tables']" routerLinkActive="active" #rla10="routerLinkActive" [attr.aria-current]="rla10.isActive ? 'page' : null"> <img class="icon" src="./assets/images/icons8-data_sheet_filled.svg" alt="" />Tables </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" [routerLink]="['/', schoolId, 'formulas']" routerLinkActive="active" #rla11="routerLinkActive" [attr.aria-current]="rla11.isActive ? 'page' : null"> <img class="icon" src="./assets/images/icons8-math.svg" alt="" />Formulas </a>
          </li>
        </ul>

        <p class="sidebar-heading" id="nav-personalization">Personalization</p>
        <ul class="nav" aria-labelledby="nav-personalization">
          <li class="nav-item">
            <a class="nav-link" [routerLink]="['/', schoolId, 'onboarding']" routerLinkActive="active" #rlaOnboarding="routerLinkActive" [attr.aria-current]="rlaOnboarding.isActive ? 'page' : null"> <img class="icon" src="./assets/images/icons8-rgb_circle_3.svg" alt="" />Branding </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" [routerLink]="['/', schoolId, 'content']" routerLinkActive="active" #rla5="routerLinkActive" [attr.aria-current]="rla5.isActive ? 'page' : null"> <img class="icon" src="./assets/images/icons8-web_design.svg" alt="" />Content </a>
          </li>
        </ul>

        <p class="sidebar-heading" id="nav-help">Help</p>
        <ul class="nav" aria-labelledby="nav-help">
          <li class="nav-item">
            <a class="nav-link" [href]="supportMailtoHref" aria-describedby="nav-support-email">
              <mat-icon class="icon" fontIcon="help_outline" aria-hidden="true"></mat-icon>
              Email support
            </a>
            <span id="nav-support-email" class="sr-only">npc_support@rewiretech.com</span>
          </li>
        </ul>

        @if ((user | async)?.admin) {
          <p class="sidebar-heading sidebar-heading--admin" id="nav-super-admin">Super admin</p>
          <ul class="nav" aria-labelledby="nav-super-admin">
            <li class="nav-item">
              <a class="nav-link" [routerLink]="['/', schoolId, 'superadmin']" routerLinkActive="active" #rla12="routerLinkActive" [attr.aria-current]="rla12.isActive ? 'page' : null"> <img class="icon" src="./assets/images/icons8-overwatch.svg" alt="" />Super Admin </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" [routerLink]="['/', schoolId, 'questions-admin']" routerLinkActive="active" #rlaQsAdmin="routerLinkActive" [attr.aria-current]="rlaQsAdmin.isActive ? 'page' : null"> <img class="icon" src="./assets/images/icons8-overwatch.svg" alt="" />Q's Admin </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" [routerLink]="['/', schoolId, 'branding']" routerLinkActive="active" #rlaAdvBranding="routerLinkActive" [attr.aria-current]="rlaAdvBranding.isActive ? 'page' : null"> <img class="icon" src="./assets/images/icons8-overwatch.svg" alt="" />Adv Branding </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" [routerLink]="['/', schoolId, 'analytics']" routerLinkActive="active" #rla14="routerLinkActive" [attr.aria-current]="rla14.isActive ? 'page' : null"> <img class="icon" src="./assets/images/icons8-overwatch.svg" alt="" />Analytics </a>
            </li>
          </ul>
        }
      </div>
    </div>
  </nav>
}
